export default __webpack_public_path__ + "static/media/prepare.529270e0.jpg";